module.exports = __webpack_public_path__ + "static/media/blueSmiley.d3190cdc.png";